export default function LinkedIn(): React.ReactElement {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>LinkedIn</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33435 0.567261C0.709246 0.567261 0.202148 1.08076 0.202148 1.71339V15.4215C0.202148 16.0542 0.709306 16.5673 1.33435 16.5673H14.3894C15.0147 16.5673 15.5216 16.0541 15.5216 15.4213V1.71339C15.5216 1.08076 15.0147 0.567261 14.3894 0.567261H1.33435ZM4.85992 6.75318V13.9564H2.56751V6.75318H4.85992ZM5.01102 4.52549C5.01102 5.21674 4.51344 5.76987 3.7142 5.76987L3.71402 5.7698H3.69918C2.92979 5.7698 2.43239 5.21668 2.43239 4.52543C2.43239 3.81849 2.94481 3.2808 3.7294 3.2808C4.51344 3.2808 4.99606 3.81849 5.01102 4.52549ZM8.42103 13.9564H6.1288L6.12874 13.9567C6.12874 13.9567 6.15884 7.42918 6.12892 6.75343H8.42121V7.77302C8.72593 7.2823 9.27131 6.5843 10.4872 6.5843C11.9954 6.5843 13.1262 7.61387 13.1262 9.8263V13.9564H10.834V10.1033C10.834 9.13487 10.5021 8.47437 9.6728 8.47437C9.03938 8.47437 8.6622 8.9198 8.49656 9.35012C8.436 9.50368 8.42103 9.71924 8.42103 9.93424V13.9564Z"
        fill="currentColor"
      />
    </svg>
  )
}

try{ LinkedIn.displayName ||= 'LinkedIn' } catch {}